<script setup lang="ts">
import { useStorage } from '@vueuse/core';
import type { AgentOnPreview } from '@@/shared/agent/types';
import type { PropertyOnList } from '@@/shared/property/api-types';
import type { PropertyOnCard } from '@@/shared/property/types';
import type { IadAppRoute } from '~/application';

const props = defineProps<{
  agent: AgentOnPreview
  property: PropertyOnList | PropertyOnCard
}>();

const agentUrl = computed<IadAppRoute<`real-estate-agent-userName`>>(() => {
  const url: IadAppRoute<`real-estate-agent-userName`> = {
    name: `real-estate-agent-userName`,
    params: { userName: props.agent.userName },
  };
  return url;
});

const route = useRoute();
const returnTo = useStorage(`agent-${props.agent.userName}`, route.fullPath);
watch(() => route.fullPath, () => {
  returnTo.value = route.fullPath;
}, { immediate: true });

function trackNavigation() {
  trackEvent({
    event: 'agent_interaction',
    event_name: 'agent_profile_click',
    agent_id: props.agent.localId,
    property_id: props.property.propertyListingRef,
    property_category: getTrackingPropertyCategory(props.property),
  });
}
</script>

<template>
  <NuxtLinkLocale
    class="relative z-10 flex gap-xs items-center pt-s mt-auto"
    :to="agentUrl"
    @click="trackNavigation"
  >
    <AgentTinyPreview :agent />
  </NuxtLinkLocale>
</template>
